import { getTravelMap, TRAVEL_TYPES } from '../../../utils/animationsUtils';
const name = 'BgFadeIn';
const properties = {
    hideOnStart: false,
    groups: ['animation', 'background'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
function animate(kit, elements, duration, delay, { componentHeight, componentTop, siteHeight, viewPortHeight, ...params } = {}) {
    const sequence = kit.sequence(params);
    const { TOP_TO_BOTTOM, CENTER_TO_CENTER } = getTravelMap(componentHeight, componentTop, siteHeight, viewPortHeight, TRAVEL_TYPES.legacy_in);
    sequence.add(kit.animate('BaseBgFade', elements, duration, delay, {
        in: {
            start: TOP_TO_BOTTOM,
            end: CENTER_TO_CENTER,
            opacity: 0,
            ease: 'sine.in',
        },
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=bgFadeIn.js.map